import React from "react";
import { Stack } from "@sanity/ui";
import { DashboardWidgetContainer } from "@sanity/dashboard";
import AlgoliaExporterControl from "./AlgoliaExporterControl";

const AlgoliaExporters: React.FC = () => {
  return (
    <DashboardWidgetContainer header="Algolia Exporters">
      <Stack>
        <AlgoliaExporterControl
          url={targetUrl("cruises")}
          label="Cruises Reindex"
        />
        <AlgoliaExporterControl
          url={targetUrl("land-experiences")}
          label="Land Experience Reindex"
        />
        <AlgoliaExporterControl
          url={targetUrl("hotels")}
          label="Hotels Reindex"
        />
      </Stack>
    </DashboardWidgetContainer>
  );
};

export default AlgoliaExporters;

const targetUrl = (target: string) => {
  const sanityImportApiUrl = process.env.SANITY_STUDIO_SILVERSEA_API!;
  return new URL(
    `/exporters-search/reindex/${target}`,
    sanityImportApiUrl
  ).toString();
};
